<template>
  <section class="container-subsection" aria-labelledby="home-hero-title">
    <div class="hero-shell">
      <div class="hero-content">
        <h1 id="home-hero-title" class="g-rez-votre-commerce">
          Gérez votre commerce floral avec simplicité.
        </h1>

        <div class="hero-body">
          <p class="text-wrapper">
            Florisuite est la plateforme tout-en-un conçue pour les
            fleuristes, offrant des outils puissants pour une gestion
            optimisée.
          </p>

          <RouterLink
            to="/inscription"
            class="button-principal"
            aria-label="Démarrer l'essai gratuit"
          >
            <span class="d-marrer-l-essai">Démarrer l'essai gratuit</span>
          </RouterLink>
        </div>
      </div>

      <img
        class="hero-image"
        alt="Interface Florisuite sur ordinateur portable"
        src="https://c.animaapp.com/nNxA75tB/img/image.png"
        loading="eager"
        fetchpriority="high"
        decoding="async"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";

export default defineComponent({
  name: "ContainerSubsection",
  components: {
    RouterLink,
  },
});
</script>

<style>
.container-subsection {
  align-self: stretch;
  background: linear-gradient(
    135deg,
    rgba(250, 250, 250, 1) 0%,
    rgba(247, 252, 243, 1) 100%
  );
  padding: clamp(56px, 7vw, 100px) clamp(16px, 4vw, 30px);
  position: relative;
  width: 100%;
}

.container-subsection .hero-shell {
  align-items: center;
  display: grid;
  gap: clamp(24px, 4vw, 64px);
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  margin: 0 auto;
  max-width: 1200px;
}

.container-subsection .hero-content {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: clamp(16px, 2.5vw, 28px);
  max-inline-size: 42rem;
}

.container-subsection .g-rez-votre-commerce {
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: clamp(1.95rem, 5.8vw, 3.75rem);
  font-weight: 700;
  line-height: 1.08;
  margin: 0;
  text-wrap: balance;
}

.container-subsection .hero-body {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: clamp(16px, 2.8vw, 36px);
  width: 100%;
}

.container-subsection .text-wrapper {
  color: #5f5f5f;
  font-family: "Poppins", Helvetica;
  font-size: clamp(1rem, 2.2vw, 1.18rem);
  font-weight: 400;
  line-height: 1.6;
  margin: 0;
  max-inline-size: 60ch;
}

.container-subsection .button-principal {
  align-items: center;
  background-color: #084734;
  border: 1px solid transparent;
  border-radius: 10px;
  box-shadow: 0px 8px 24px rgba(8, 71, 52, 0.14);
  color: #ffffff;
  display: inline-flex;
  font-family: "Open Sans", Helvetica;
  font-size: 0.95rem;
  font-weight: 700;
  justify-content: center;
  min-height: 46px;
  min-width: 220px;
  padding: 10px 20px;
  text-decoration: none;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease, border-color 0.18s ease;
}

.container-subsection .button-principal:hover {
  background-color: #0a5a42;
  box-shadow: 0px 10px 26px rgba(10, 90, 66, 0.2);
  transform: translateY(-1px);
}

.container-subsection .button-principal:active {
  transform: translateY(0);
}

.container-subsection .button-principal:focus-visible {
  border-color: rgba(255, 255, 255, 0.75);
  outline: 2px solid rgba(8, 71, 52, 0.35);
  outline-offset: 2px;
}

.container-subsection .d-marrer-l-essai {
  line-height: 1.2;
  text-align: center;
}

.container-subsection .hero-image {
  aspect-ratio: 4 / 3;
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(12, 24, 18, 0.12);
  justify-self: end;
  max-height: 540px;
  object-fit: cover;
  width: min(100%, 640px);
}

@media (max-width: 1024px) {
  .container-subsection .hero-shell {
    grid-template-columns: 1fr;
  }

  .container-subsection .hero-content {
    max-inline-size: 100%;
  }

  .container-subsection .hero-image {
    justify-self: start;
    width: min(100%, 760px);
  }
}

@media (max-width: 768px) {
  .container-subsection .button-principal {
    min-width: 0;
    width: 100%;
  }

  .container-subsection .hero-image {
    border-radius: 12px;
  }
}

/* Legacy selectors kept as no-op safety for older snapshots */
.container-subsection .frame,
.container-subsection .div,
.container-subsection .frame-2,
.container-subsection .image {
  min-width: 0;
}
</style>
